/*
 * @Author: Roman
 * @Date: 2023-02-22 14:50:52
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-11-07 18:55:23
 * @FilePath: \qpmn-site\src\app\modules\base\AppConfiguration.ts
 * @Description: 
 */
import angular from "angular";
import { Languages } from "../../../../language/Languages";
import { languages } from "../../../../language/language.bootstrap";
import { appConfig } from "@env/app-config";
import { BrowserChecker } from "./service/browser-checker";

function AppConfiguration($translateProvider: angular.translate.ITranslateProvider) {
    BrowserChecker.lowVersionCheck();
    for (var i in appConfig.SUPPORT_LANGUAGE) {
        if (Object.hasOwnProperty.call(appConfig.SUPPORT_LANGUAGE, i)) {
            var lan = appConfig.SUPPORT_LANGUAGE[i];

            //旧的多语言，后续不再使用
            var lanConfig = Languages[lan];
            
            if (lanConfig != null || lanConfig != undefined) {
                var lanComponent = lanConfig["component"];
                var lanSystem = lanConfig["system"];
                var lanRest = lanConfig["rest"];
            }

            //新的多语言
            var langConfig = languages[lan];

            var dict = {}

            angular.extend(dict, lanSystem, lanComponent, lanRest, langConfig);

            $translateProvider.translations(lan, dict);
        }
    }
    $translateProvider
        .preferredLanguage(appConfig.DEFAULT_LANGUAGE) //设置默认语言
        .fallbackLanguage(appConfig.SUPPORT_LANGUAGE) //设置备选语言
        .useSanitizeValueStrategy('sceParameters'); //翻译策略，增加安全性
}

let injector = ["$translateProvider", AppConfiguration]

export { injector }